import React from 'react';
import { Drawer as MaterialDrawer, Box, Backdrop } from '@material-ui/core';

export function Drawer({
  containerId,
  open,
  onClose,
  children,
  anchor = 'right',
}) {
  return (
    <Box>
      <Backdrop
        open={open}
        onClick={onClose}
        className="position-absolute"
        style={{ zIndex: 1099 }}
      />
      <MaterialDrawer
        variant="persistent"
        anchor={anchor}
        open={open}
        onClose={onClose}
        SlideProps={{
          unmountOnExit: true,
        }}
        PaperProps={{
          className: 'position-absolute',
          style: {
            zIndex: 1100,
          },
        }}
        BackdropProps={{
          className: 'position-absolute',
        }}
        ModalProps={{
          container: document.getElementById(containerId),
          className: 'position-absolute',
          disableEnforceFocus: true,
          disableScrollLock: true,
        }}
      >
        {children}
      </MaterialDrawer>
    </Box>
  );
}
